import Vue from 'vue'
import Router from 'vue-router'
import AppService from "@/services/AppService";
import Biometria from '@/components/pages/Biometria';
import Selfie from "../components/pages/Selfie";
import SelfieIntroducao from "../components/pages/SelfieIntroducao";
import ConfirmarIdentidade from "../components/pages/ConfirmarIdentidade";
import TermoUso from "../components/pages/TermoUso";
import Analise from "../components/pages/Analise";
import DocSelecao from '../components/pages/DocSelecao.vue';
import DocDigitalizacao from '../components/pages/DocDigitalizacao.vue';
import NewDocDigitalizacao from '../components/pages/NewDocDigitalizacao.vue';
import DocCnhDigital from '../components/pages/DocCnhDigital.vue';
import Liveness2D from "../components/pages/Liveness2D";
import LivenessSerasa from "../components/pages/LivenessSerasa";
import LivenessCaf from "../components/pages/LivenessCaf";
import ConsultaBaseSerasa from '../components/pages/ConsultaBaseSerasa';

const Falha = () => System.import(/* webpackChunkName: "group-falha" */'../components/pages/Falha.vue')

Vue.use(Router)

var app = new AppService();
const linkValido = (to,from,next) => {
  app.buscarDadosLink()
    .then(() => next())
    .catch((error) => {
      alert(error);
      next({name: 'Falha'})
    });
}

export default new Router({
  routes: [
    { path: '*', component: Falha},
    {
      path: '/falha',
      name: 'Falha',
      component: Falha
    },
    {
      path: '/biometria/:codigo',
      name: 'Biometria',
      component: Biometria
    },
    {
      path: '/selfie/dicas/',
      name: 'SelfieIntroducao',
      component: SelfieIntroducao,
      beforeEnter: linkValido
    },
    {
      path: '/selfie/LivenessFacetec/',
      name: 'Selfie',
      component: Selfie,
      beforeEnter: linkValido
    },
    {
      path: '/selfie/liveness2D/',
      name: 'Liveness2D',
      component: Liveness2D,
      beforeEnter: linkValido
    },
    {
      path: '/selfie/livenessSerasa/',
      name: 'LivenessSerasa',
      component: LivenessSerasa,
      beforeEnter: linkValido
    },
    {
      path: '/selfie/livenessCaf/',
      name: 'LivenessCaf',
      component: LivenessCaf,
      beforeEnter: linkValido
    },
    {
      path: '/doc/selecao/',
      name: 'DocSelecao',
      component: DocSelecao,
      beforeEnter: linkValido
    },
    // {
    //   path: '/doc/digitalizacao/',
    //   name: 'DocDigitalizacao',
    //   component: DocDigitalizacao,
    //   beforeEnter: linkValido
    // },
    {
      path: '/doc/digitalizacao/',
      name: 'NewDocDigitalizacao',
      component: NewDocDigitalizacao,
      beforeEnter: linkValido
    },
    {
      path: '/doc/doc-cnh-digital/',
      name: 'DocCnhDigital',
      component: DocCnhDigital,
      beforeEnter: linkValido
    },
    {
      path: '/confirmar-identidade/',
      name: 'ConfirmarIdentidade',
      component: ConfirmarIdentidade,
      beforeEnter: linkValido
    },
    {
      path: '/termo-de-uso/',
      name: 'TermoUso',
      component: TermoUso,
      beforeEnter: linkValido
    },
    {
      path: '/analise/',
      name: 'Analise',
      component: Analise,
      beforeEnter: linkValido
    },
    {
      path: '/consulta-base/',
      name: 'ConsultaBaseSerasa',
      component: ConsultaBaseSerasa,
      beforeEnter: linkValido
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js